import React, { useEffect, useState } from 'react';
import axiosInstance from '../../axiosInstance';
import { URL } from '../../api.jsx';
import getPrivilegeList from '../PrivilegeList.jsx';

const CompanyList = () => {
  const privilegeList = getPrivilegeList();

  /* ===================== LIST STATE ===================== */
  const [companies, setCompanies] = useState([]);

  /* ===================== FILTER STATE ===================== */
  const [filterType, setFilterType] = useState('');
  const [filterValue, setFilterValue] = useState('');

  /* ===================== DROPDOWN DATA ===================== */
  const [companyDropdown, setCompanyDropdown] = useState([]);

  /* ===================== PAGINATION ===================== */
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  /* ===================== FETCH DROPDOWN ===================== */
  const fetchCompanyDropdown = async () => {
    try {
      const res = await axiosInstance.get(URL.COMPANY_LIST_BY_CODE);
      if (Array.isArray(res.data)) {
        setCompanyDropdown(res.data);
      } else {
        setCompanyDropdown([]);
      }
    } catch (err) {
      console.error('Error fetching company dropdown:', err);
      setCompanyDropdown([]);
    }
  };

  /* ===================== FETCH COMPANIES ===================== */
  const fetchCompanies = async () => {
    try {
      const params = new URLSearchParams();

      if (filterType === 'companyCode' && filterValue) {
        params.append('companyCode', filterValue);
      }
      if (filterType === 'gstNumber' && filterValue) {
        params.append('gstNumber', filterValue);
      }

      const res = await axiosInstance.get(
        `${URL.GET_ALL_COMPANY}?${params.toString()}`
      );

      if (res.data && Array.isArray(res.data.data)) {
        setCompanies(res.data.data);
        setCurrentPage(1);
      } else {
        setCompanies([]);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
      setCompanies([]);
    }
  };

  useEffect(() => {
    fetchCompanies();
    fetchCompanyDropdown();
  }, []);

  /* ===================== PAGINATION ===================== */
  const totalPages = Math.ceil(companies.length / rowsPerPage);
  const paginatedCompanies = companies.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="container">
      {/* ===================== HEADER ===================== */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Company List</h3>

        {privilegeList.companyAdd && (
          <button
            className="btn btn-sm btn-success"
            onClick={() => (window.location.href = '#/CompanyAddEdit')}
          >
            + Add Company
          </button>
        )}
      </div>

      {/* ===================== FILTER SECTION ===================== */}
      <div className="card mb-4 p-3">
        <div className="row gx-2 gy-2 align-items-end">
          <div className="col-auto">
            <label className="form-label">Filter Type</label>
            <select
              className="form-select form-select-sm"
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setFilterValue('');
              }}
            >
              <option value="">Select</option>
              <option value="companyCode">Company</option>
              <option value="gstNumber">GST Number</option>
            </select>
          </div>

          {/* Company Code Dropdown */}
          {filterType === 'companyCode' && (
            <div className="col-auto">
              <label className="form-label">Company</label>
              <select
                className="form-select form-select-sm"
                value={filterValue}
                onChange={(e) => setFilterValue(e.target.value)}
              >
                <option value="">Select Company</option>
                {companyDropdown.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.value}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* GST Number Input */}
          {filterType === 'gstNumber' && (
            <div className="col-auto">
              <label className="form-label">GST Number</label>
              <input
                type="text"
                className="form-control form-control-sm"
                value={filterValue}
                onChange={(e) => setFilterValue(e.target.value)}
              />
            </div>
          )}

          <div className="col-auto">
            <button
              className="btn btn-sm btn-primary mt-1"
              onClick={fetchCompanies}
            >
              Search
            </button>
          </div>
        </div>
      </div>

      {/* ===================== TABLE ===================== */}
      <div className="table-responsive" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <table className="table tablestyle table-sm table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No.</th>
              <th>Company Code</th>
              <th>Company Name</th>
              <th>GST Number</th>
              <th>Authorized Person</th>
              <th>SPOC</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Account No.</th>
              <th>IFSC Code</th>
              <th>Status</th>
              <th>Registered Date</th>
              {privilegeList.companyEdit && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {paginatedCompanies.length > 0 ? (
              paginatedCompanies.map((company, index) => (
                <tr key={company.companyCode}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{company.companyCode}</td>
                  <td>{company.companyName}</td>
                  <td>{company.gstNumber}</td>
                  <td>{company.authorizedPersonName}</td>
                  <td>{company.spocPersonName}</td>
                  <td>{company.email}</td>
                  <td>{company.mobileNumber}</td>
                  <td>{company.accountNumber}</td>
                  <td>{company.ifscCode}</td>
                  <td>
                    <span
                      className={`badge rounded-pill ${
                        company.status === 'ACTIVE'
                          ? 'bg-success'
                          : 'bg-secondary'
                      }`}
                    >
                      {company.status}
                    </span>
                  </td>
                  <td>{company.createdAt ? String(company.createdAt).replace("T", " ").slice(0, 19) : "-"}</td>

                  {privilegeList.companyEdit && (
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() =>
                          (window.location.href = `#/CompanyAddEdit?companyCode=${company.companyCode}`)
                        }
                      >
                        Edit
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center text-muted">
                  No company records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ===================== PAGINATION ===================== */}
      {companies.length > rowsPerPage && (
        <div className="d-flex justify-content-center mt-3">
          <div className="d-flex align-items-center" style={{ gap: '5px' }}>
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={`btn btn-sm ${
                  currentPage === i + 1
                    ? 'btn-primary'
                    : 'btn-outline-primary'
                }`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() =>
                setCurrentPage((p) => Math.min(p + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyList;